export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10374.81c2855c.jpg";